"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getVueApp = exports.hasVueApp = exports.setVueApp = exports.isVue3 = void 0;
var vueApp;

function isVue3(vue) {
  if (vue === void 0) {
    vue = vueApp;
  }

  if (!vue) {
    throw new Error('global Vue in vue2 or app instance in vue3 is required');
  }

  var _vue = vue,
      version = _vue.version;

  if (typeof version !== 'string' || !/^\d+\./.test(version)) {
    return false;
  }

  var _version$split = version.split('.'),
      major = _version$split[0];

  return parseInt(major, 10) >= 3;
}

exports.isVue3 = isVue3;

function setVueApp(vue) {
  vueApp = vue;
}

exports.setVueApp = setVueApp;

function hasVueApp() {
  return !!vueApp;
}

exports.hasVueApp = hasVueApp;

function getVueApp() {
  return vueApp;
}

exports.getVueApp = getVueApp;